<template>
  <div class="color-codes-content" id="identidade-visual-cores-codigos" data-search-anchor>
    <div class="color-codes-title-wrapper">
      <h1 class="color-codes-title-span">{{ colorCodesTitleSpan }}</h1>
      <h1 class="color-codes-title">{{ colorCodesTitle }}</h1>
    </div>

    <div class="description-color-gradients-title-icons-wrapper">
      <div class="color-codes-first">
        <p class="color-codes-description">{{ colorCodesDescription }}</p>
      </div>
      <div class="color-codes-icon-wrapper">
        <IconCancel />
        <p class="color-codes-description-icon">{{ colorCodesDescription1 }}</p>
      </div>
    </div>

    <div class="color-row first-row">
      <div v-for="(item, i) in firstRowColors" :key="'first-' + i" class="color-block large"
        :class="[item.textColor, { 'with-border': item.hex.toLowerCase() === '#ffffff' }]"
        :style="{ backgroundColor: item.hex }">
        <strong class="color-title">{{ item.title }}</strong>
        <p class="color-text" v-html="item.text" />
      </div>
    </div>

    <div class="color-row second-row">
      <div v-for="(item, i) in secondRowColors" :key="'second-' + i" class="color-block small"
        :class="[item.textColor, { 'with-border': item.hex.toLowerCase() === '#ffffff' }]"
        :style="{ backgroundColor: item.hex }">
        <strong class="color-title">{{ item.title }}</strong>
        <p class="color-text" v-html="item.text" />
      </div>

    </div>
  </div>
</template>


<script lang="ts">
import IconCancel from '@/assets/icons/IconCancel.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import ColorPageMixin from '@/mixins/color-page-mixin'
import { ColorPageStore } from '@/store/visual-identity-page/color-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCancel } })
export default class ColorCodesSection extends Mixins(ColorPageMixin) {
  colorPageStore: PageStoreContract = getModule(ColorPageStore, this.$store)

  get colorCodesTitleSpan(): string {
    return this.getElementTitle(6, 0)
  }

  get colorCodesTitle(): string {
    return this.getElementText(6, 0)
  }

  get colorCodesDescription(): string {
    return this.getElementText(6, 1)
  }

  get colorCodesDescription1(): string {
    return this.getElementText(6, 2)
  }

  formatColorText(text: string): string {
  return text
    .replace(/Pantone\s*([^\n]+)/, '<strong>Pantone</strong><br>$1<br><br>')
    .replace(/HEX\s*([^\n]+)/, '<strong>HEX</strong><br>$1<br><br>')
    .replace(/RGB\s*([^\n]+)/, '<strong>RGB</strong><br>$1<br><br>')
    .replace(/CMYK\s*([^\n]+)/, '<strong>CMYK</strong><br>$1')
}

  get firstRowColors() {
    return [3, 4, 5, 6].map((i, idx) => {
      const block = this.getColorBlock(i)
      const textColor = idx < 3 ? 'text-white' : 'text-black'
      return { ...block, textColor }
    })
  }

  get secondRowColors() {
    return [7, 8, 9, 10, 11].map((i, idx) => {
      const block = this.getColorBlock(i)
      const textColor = idx === 0 ? 'text-white' : 'text-black'
      return { ...block, textColor }
    })
  }

  getColorBlock(index: number) {
    const text = this.getElementText(6, index)
    return {
      title: this.getElementTitle(6, index),
      text: this.formatColorText(text),
      hex: text.match(/HEX\s*(#[A-Fa-f0-9]{6})/)?.[1] || '#ffffff',
    }
  }

  async mounted(): Promise<void> {
    if (!this.colorPageStore.isLoading) {
      await this.colorPageStore.getDataPage()
    }
  }
}
</script>


<style lang="scss">
.color-codes-content {
  display: grid;
  max-width: 1032px;
  width: 100%;
}

.color-codes-title-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 1rem;
}

.color-codes-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  margin-right: 5px;
  color: #b3b3b3;
}

.color-codes-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  color: #000;
}

.description-color-gradients-title-icons-wrapper {
  display: grid;
  grid-template-columns: 51.5% 48.5%;  
}

.color-codes-description{
  white-space: pre-line;  
}

.color-codes-description,
.color-codes-description-icon {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  white-space: pre-line;
}

.color-codes-icon-wrapper {
  display: flex;
  align-items: center;
}

.color-codes-description-icon {
  padding-left: 7px;
  width: 378px;
}

.color-row {
  display: grid;
  gap: 2rem; 
}

.first-row {
  grid-template-columns: repeat(4, 1fr);
  margin-bottom: 2rem;
}

.second-row {
  grid-template-columns: repeat(5, 1fr);
}

.color-block {
  padding: 1rem;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  font-family: GlobotipoCorporativaTextosRegular;
}

.color-block.large {
  height: 300px;
}

.color-block.small {
  height: 300px;
}

.color-block.with-border {
  border: 1px solid black;
}

.text-white {
  color: #fff;
}

.text-black {
  color: #000;
}

.color-title {
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.color-text {
  font-size: 12px;
  line-height: 1.1;
}
</style>
